import 'css-chunksrc/client/pages/documentsPage/reportsPage/reportsList/report/indicatorsList/styles.scss';export default {
  "indicatorsList": "_indicatorsList_1n2zx_1",
  "input": "_input_1n2zx_10",
  "indicator": "_indicator_1n2zx_1",
  "name": "_name_1n2zx_27"
};